// @flow

import queryString from 'querystring'

import { getIdToken } from 'services/auth'

const apiUrl = process.env.REACT_APP_ONEBLINK_API_ORIGIN || ''

async function generateHeaders() {
  const idToken = await getIdToken()
  return {
    Authorization: `Bearer ${idToken}`,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }
}

async function fetchJSON(url, options) {
  try {
    const response = await fetch(url, options)

    const body = await response.json()
    if (response.ok) {
      return body
    }

    throw new Error(body.message)
  } catch (error) {
    if (error.message.toLowerCase() === 'failed to fetch') {
      throw new Error(
        'There has been a network error, please check your network and try again.'
      )
    }
    throw error
  }
}

export async function searchEndpoint<T>(
  path: string,
  searchParameters: { [key: string]: any }
): Promise<T> {
  const queryStringParams = queryString.stringify(searchParameters || {})
  const body = await getEndpoint(`${path}?${queryStringParams}`)
  return body
}

export async function getEndpoint<T>(path: string): Promise<T> {
  const url = `${apiUrl}${path}`
  const options = {
    method: 'GET',
    headers: await generateHeaders(),
  }

  return fetchJSON(url, options)
}

export async function postEndpoint<T, OutT>(
  path: string,
  resource: T
): Promise<OutT> {
  const url = `${apiUrl}${path}`
  const opts = {
    method: 'POST',
    headers: await generateHeaders(),
    body: JSON.stringify(resource),
  }

  return fetchJSON(url, opts)
}

export async function putEndpoint<T, OutT>(
  path: string,
  resource: T
): Promise<OutT> {
  const url = `${apiUrl}${path}`
  const opts = {
    method: 'PUT',
    headers: await generateHeaders(),
    body: JSON.stringify(resource),
  }

  return fetchJSON(url, opts)
}

export async function deleteEndpoint(path: string): Promise<void> {
  const url = `${apiUrl}${path}`
  const opts = {
    method: 'DELETE',
    headers: await generateHeaders(),
  }

  const res = await fetch(url, opts)
  if (!res.ok) {
    const errorPayload = await res.json()
    throw new Error(errorPayload.message)
  }
}
